const Z_INDEX = {
  DRAG_IMAGE_ELEMENT: -1,

  /* We want the numbered column to be lower than the table row for vertical scroll */
  TABLE_NUMBERED_COLUMN: 2,

  TABLE_ROW: 3,

  /* Above frozen body cells, but below sticky table chrome during vertical scroll */
  TABLE_CELL_EDITOR: 5,

  STICKY_SHADOW: 90,

  TABLE_VIEW_INSERT_DOT: 128,

  // Same value as TABLE_VIEW_INSERT_DOT to ensure dots show over header + blue line on hover
  TABLE_LAYOUT_HEADER_ROW: 128,

  // we want row select button to be higher than the row drop indicator
  ROW_SELECT_BUTTON: 116,
  TABLE_VIEW_ROW_DROP_INDICATOR: 115,

  TABLE_RESIZE_HANDLER: 130,

  TABLE_VIEW_SELECTION_TOOLBAR: 133,

  TABLE_VIEW_DROP_INDICATOR: 135,
  COLUMN_SELECT_BUTTON: 140,

  /** Inline dialogs (Popups that may contain dropdowns and selects and may be used in dialogs) */
  INLINE_DIALOG: 510,

  /** Color picker (can be opened from inside a Select) */
  COLOR_PICKER: 760,

  /* Tooltip (used for Popups that act as a tooltip) */
  TOOLTIP: 800,

  /* PopoverEdit Container for all multi select popover edits*/
  POPOVER_EDIT_CONTAINER: 900,

  /* Table Layout horizontal scroll fade gradient */
  SCROLL_FADE_GRADIENT: 41,

  ADD_ENTRY_QUICK_CALC_CONTAINER: 40,
  SIDE_PANEL_CONTAINER: 200
};

export default Z_INDEX;
